import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { Subject, Subscription, switchMap, takeUntil, timer } from 'rxjs';
import { EnvService } from '../../../..//services/env.service';
import { USER_MGMT_DATA_CNST } from '../../../../constants/data.cnst';
import { PROJECT_CONSTANTS, USER_MGMT_CNST, USER_MGMT_DEFAULT_CONFIG_CNST } from '../../../../constants/proj.cnst';
import { DropDownConfig } from '../../../../interfaces/dropdown.config';
import { CustomValidators, isEmptyObject, isNullOrUndefined } from '../../../../modules/shared';
import { AppStateService } from '../../../../services/app-state.service';
import { DataService } from '../../../../services/data.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';
import { CustomerService } from '../../customer.service';
import { BreadCrumsConstant } from '../../../../modules/shared/components/primeng-breadcrumb/breadcrumb.constants';
import { ImportsModule } from '../../../../modules/imports/imports';
import { SkeletonComponent } from '../../../../modules/shared/components/skeleton/skeleton.component';
import { PrimengBreadcrumbComponent } from '../../../../modules/shared/components/primeng-breadcrumb/primeng-breadcrumb.component';
import { CustomPhoneNumberComponent } from '../../../../modules/shared/components/custom-phone-number/custom-phone-number.component';
import { AddCustomerAdminComponent } from '../add-customer-admin/add-customer-admin.component';
import { AssignResourcesComponent } from '../assign-resources/assign-resources.component';
import { StepsModule } from 'primeng/steps';
import { SearchFilterPipe } from '../../../../pipes/search-filter.pipe';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { TablerIconComponent,provideTablerIcons } from 'angular-tabler-icons';

interface UploadEvent {
  originalEvent: Event;
  files: File[];
}
@Component({
  selector: 'app-add-or-edit-customer',
  templateUrl: './add-or-edit-customer.component.html',
  standalone : true,
  imports : [
    ImportsModule,
    SkeletonComponent,
    PrimengBreadcrumbComponent,
    CustomPhoneNumberComponent,
    AddCustomerAdminComponent,
    AssignResourcesComponent,
    SearchFilterPipe,
    StepsModule,
    TablerIconComponent
],providers: [ 
provideTablerIcons({ ...TablerIcons })
]
})
export class AddOrEditCustomerComponent implements OnInit {

  emailPattern: any = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  isEmailValid: boolean = true;
  isDragging: boolean = false;

  isCustomerDropdownRequired: boolean = false;
  customerDropDownValues: DropDownConfig[] = [];
  selectedTypeValues: any = {};
  customerAttributes: any[] = [];
  areCustomerAttributesFilled: boolean = false;

  isApplicationTableDataLoaded: boolean = false;

  isPrimaryMobileNoValid: boolean = true;
  isSecondaryMobileNoValid: boolean = true;
  currentCountryCode: string = "in";

  customerDetails: any = {
    customerName: null,
    email: null,
    primaryMobileNo: null,
    secondaryMobileNo: null,
    address: null,
    billingAddress: null,
    editPrimaryMobileNo: null,
    logo: null,
    domain: null,
  };

  formDataCopy: any = {
    billing_address: null,
    com_address: null,
    email: null,
    name: null,
    primary_contact: null,
    secondary_contact: null
  }

  billingAddressToggleFlag: boolean = false;
  isEdit: boolean = true;
  customerAdmin: any = null;
  customerId: any = null;
  subscriptions: Subscription[] = [];
  operation: any;

  assignedResources: any = {};
  operationType: any;

  applicationsResourcesInfo: any = {};
  isApplicationsAssigned: boolean = false;
  hasAssignedResources: boolean = false;
  showCustomerAdmin: boolean = false;
  customerAdminEmail: any = null;
  secondaryContactValid: boolean = true;
  stepConfigB: {
    info: number,
    admin: number,
    resources: number,
  } = {
      info: 0,
      admin: 1,
      resources: 2,
    };

  activeStep: number = 0;
  customerAdminInfo: any;
  currentTab: string = 'info';
  applicationsList: any[] = [];
  applicationSelectedStatus: any = {};
  applicationSelectedStatusCopy: any = {};
  //* Map of application names to application id's
  applicationNameIdMap: any = {};
  //* Map of application names to resource action id's
  applicationNameResourceActionIdMap: any = {};

  applicationNames: string[] = [];
  applicationIds: string[] = [];

  isButtonEnabled: boolean = false;

  modalTitle: any = null;
  buttonText: any = null;
  payloaddata: any = { applicationIdsToDelete: [], customerId: '', resourceActionIdsToAdd: [], applicationIdsToAdd: [], resourceActionIdsToDelete: [] };
  applicationIdsToAdd: any = [];
  applicationIdsToDelete: any = [];
  unchekedList: any = [];
  chekedList: any = [];
  appsListWithResources: any;
  loading: boolean = false;
  customPhoneForm = new FormGroup({
    country: new FormControl<{ name: string; dial_code: string; code: string; flag: string } | null>(null, Validators.required),
    phoneNumber: new FormControl<string>('', [Validators.required, this.validatePhoneNumber.bind(this)])
  });
  isImageInvalid: boolean = false;
  imageFile: any;
  currentCustomerLogo: string | ArrayBuffer | undefined | null;
  previousSelectedFile!: any;
  customerDetailsForm!: FormGroup;
  searchTerm!: string;
  openCropPopUp: boolean = false;
  fileEvent: any;
  @ViewChild('fileInput') fileInput!: ElementRef;
  selectedCountry!: { name: string; dial_code: string; code: string; flag: string; };
  resourcesIdsList: any;
  isFileBrowserOpened: boolean = false;
  isResourceClickable: boolean = true;
  items:{ [key: string]: MenuItem[] } = BreadCrumsConstant;
  applicationListLoading:boolean = false;
  isAddUpdateButtonClicked : boolean = false;

  constructor(
    private httpSrv: HttpService,
    private utilSrv: UtilsService,
    private appState: AppStateService,
    private dataSrv: DataService,
    private envService: EnvService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private fb: FormBuilder,
    private utilsService: UtilsService,
    private custService: CustomerService
  ) { 
  }

  onUpload(event: UploadEvent) {
    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded with Basic Mode' });
  }

  async ngOnInit() {
    this.inItMethod();
    this.subscribeRouterEvents();
    this.updateBreadcrumb(this.operation);
  }

  inItMethod() {
    this.selectedCountry = USER_MGMT_DEFAULT_CONFIG_CNST.INITIAL_COUNTRY_DATA;
    this.customPhoneForm.patchValue({
      country: this.selectedCountry,
      phoneNumber: ''
    });
    let customerData = this.appState.getCustomerData();
    this.initCustomerDetailsForm()
    this.handleInputFormatting();
    this.areCustomerAttributesFilled = !this.isCustomerDropdownRequired;
    if (customerData) {
      this.setInitialCustomerInfo();
    }
    let dropDownLabels = this.customerDropDownValues.map((item: any) => item.label);
    for (let label of dropDownLabels) {
      this.selectedTypeValues[label] = null;
    }
  }

  subscribeRouterEvents() {
    const queryParamsRef = this.route.queryParams.subscribe(async (params: Params) => {
    
      this.billingAddressToggleFlag = false
      this.loading = true;
      try {
        let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;
        const tabs = Object.keys(this.stepConfigB);
        let operation = params['operation'];
        let customerId = params['customerId'] || this.customerId || null;
        if (operation !== 'new') {
          this.operation = operation;
        } else {
          this.operation = (params['config'] && (params['config'] == 'info' || 'admin')) ? 'edit' : operation;
        }
        this.isEdit = this.operation === CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER;
        this.areCustomerAttributesFilled = !!(this.isEdit && this.isCustomerDropdownRequired);
        this.isApplicationTableDataLoaded = this.operation === CUSTOMER_MODULE_OPERATIONS.ADD_CUSTOMER;
        if (!isNullOrUndefined(customerId)) {
          this.appState.setCurrentCustomerId(customerId);
          this.customerId = customerId;
        }
        await this.handleApplicationsListBasedOnTab(params, tabs, CUSTOMER_MODULE_OPERATIONS);
      } catch (error) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
      this.utilSrv.disableStepper(this.isResourceClickable);

    });

    this.subscriptions.push(queryParamsRef);
  }

  async handleApplicationsListBasedOnTab(params: any, tabs: any, CUSTOMER_MODULE_OPERATIONS: any) {
    if (this.operation === CUSTOMER_MODULE_OPERATIONS.VIEW_CUSTOMER || this.operation === CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER) {
      if (params['config'] && tabs.includes(params['config'])) {
        this.currentTab = params['config'];
        type StepConfigKeys = keyof typeof this.stepConfigB;
        // Ensure params['config'] is a valid key of stepConfig
        const configKey = params['config'];
        const currentTab = configKey as StepConfigKeys;
        this.activeStep = this.stepConfigB[currentTab];
      }
      await this.handleViewOrEditCustomerOnRefresh(this.customerId);

    } else if(this.currentTab == 'resources') {
      //* Get all assigned resources for all assigned apps
      //* for a customer Api Call
      this.fetchAllActiveApplications(this.customerId);
      this.fetchAllAssignedResourcesUnderAssignedAppsForCustomer(this.customerId);
    }
  }

  validatePhoneNumber(control: FormControl): { [key: string]: boolean } | null {
    const country = this.customPhoneForm?.get('country')?.value;
    return null;
    // return this.utilsService?.validateMobileNumber(control, country);
  }

  onCountryChange(event: any) {
    this.customPhoneForm.patchValue({
      country: event?.value,
      phoneNumber: ''
    });
  }

  updateBreadcrumb(operation: string) {
    if (this.items && this.items['addCustomer']) {
      const label = 
        operation === 'view' ? 'View Organization' :
        operation === 'edit' ? 'Edit Organization' :
        'Add Organization'; // Default value
  
      // Ensure the second item exists; if not, add it
      if (this.items['addCustomer'].length < 2) {
        this.items['addCustomer'].push({ label, routerLink: '/usermgmt/customer' });
      } else {
        // Update existing item at index 1
        this.items['addCustomer'][1].label = label;
      }
  
      // Replace the array to ensure change detection
      this.items['addCustomer'] = [...this.items['addCustomer']];
    }
  }

  initCustomerDetailsForm() {
    this.customerDetailsForm = this.fb.group({
      logo: [null],
      customerName: ['', [Validators.required,Validators.minLength(2), Validators.maxLength(25), Validators.pattern(/^(?!-)(?!.*--)[A-Za-z0-9]+(-[A-Za-z0-9]+)*(?: [A-Za-z0-9]+(-[A-Za-z0-9]+)*)*$/)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(50), this.utilSrv.restrictedEmailCharactersValidator]],
      phone: [''],
      address: ['', [CustomValidators.noWhitespaceValidator, this.optionalValidator(Validators.required)]],
      billingAddress: ['', [CustomValidators.noWhitespaceValidator, this.optionalValidator(Validators.required)]],
      billingAddressSame: [false],
    });
  }

  //formats the customer name field data
  handleInputFormatting() {
    this.customerDetailsForm.get('customerName')?.valueChanges.subscribe(value => {
      if (value !== null) {
        const formattedValue = value
          .replace(/^\s+/, '') // Remove leading and trailing spaces
          .replace(/\s+/g, ' ');  // Replace multiple spaces with a single space
        if (formattedValue !== value) {
          this.customerDetailsForm.get('customerName')?.setValue(formattedValue, { emitEvent: false });
        }
      }
    });
  }

  fetchCustomerTypeValues(): Promise<DropDownConfig[]> {
    const postData = {};
    const promise = new Promise<DropDownConfig[]>((resolve, reject) => {
      const dropDownDetails: DropDownConfig = {
        label: 'cust_type_uuid',
        values: []
      }
      this.httpSrv.makePostApiCall('FETCH_CUSTOMER_TYPE', postData, this.envService.applicationBaseUrl).subscribe({
        next: (customerType: any[]) => {
          console.log(customerType);
          dropDownDetails.values = customerType
          resolve([dropDownDetails]);
        },
        error: () => {
          resolve([dropDownDetails])
        }
      })
    })
    return promise;
  }


  activateCallback(tab : string, stepchange : any) {
    this.onToggleTab(tab, stepchange)
  }

  onToggleTab(tab: string, stepchange: any) {
    const tabs = Object.keys(this.stepConfigB);
    if (this.customerId) {
      this.currentTab = tab;
      tabs.forEach((tabs: any) => {
        if (tabs === tab) {
          this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
            queryParams: {
              config: tab
            },
            queryParamsHandling: 'merge'
          })
        }
      });
    }
    if(tab === 'admin'){
      this.isResourceClickable = true;
    }
  }

  navigateToCustomerView() {
    this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
      queryParamsHandling: 'merge'
    });
  }

  assignOrUpdateResources() {
    if (this.unchekedList.length > 0) {
      const data = this.appsListWithResources.response;
      this.unchekedList.forEach((uncheckedKey: string) => {
        const matchedData = data[uncheckedKey];
        if (matchedData && !isEmptyObject(matchedData)) {
          this.processMatchedData(matchedData, uncheckedKey);
        } else {
          this.processApplicationsList(uncheckedKey);
        }
      });
    }
    this.updateAssignedResources()
  }

  private processMatchedData(matchedData: any, uncheckedKey: string): void {
    if (!isEmptyObject(matchedData)) {
      this.payloaddata['applicationIdsToDelete'].push(matchedData['Dashboards'][0]['applicationId']);
      matchedData['Dashboards'].forEach((dashboard: any) => {
        this.payloaddata['resourceActionIdsToDelete'].push(dashboard['resourceActionId']);
      });
    }
  }

  private processApplicationsList(uncheckedKey: string): void {
    this.applicationsList.forEach((element) => {
      if (element['applicationName'] === uncheckedKey) {
        this.payloaddata['applicationIdsToDelete'].push(element['applicationId']);
      }
    });
  }

  updateAssignedResources() {
    this.isAddUpdateButtonClicked = true;
    setTimeout(() => {
      this.isAddUpdateButtonClicked = false
    }, 2000);
    const isCEApplicationPresent = this.applicationsList.find((application: any) => application?.applicationName === PROJECT_CONSTANTS?.APPLICATION_NAME);
    const hasConnectedEnterprise: boolean = this.chekedList?.includes(isCEApplicationPresent?.applicationId)
    if (hasConnectedEnterprise || this.applicationSelectedStatusCopy[PROJECT_CONSTANTS?.APPLICATION_NAME]) {
      if (this.chekedList.length > 0) {
        for (let key in this.chekedList) {
          this.payloaddata['applicationIdsToAdd'].push(this.chekedList[key])
        }
      }
      this.payloaddata['customerId'] = this.customerId;
      this.loading = true;
      this.httpSrv.makePostApiCall('ASSIGN_OR_UPDATE_RESOURCES', this.payloaddata, this.envService.baseUrl).pipe(
        switchMap(response => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: USER_MGMT_DATA_CNST.TOASTER_MSG.UPDATE_RESOURCES });
          return timer(1000); // Delay the navigation by 1000ms
        })

      ).subscribe({
        next: () => {
          this.loading = false;
          this.router.navigate(['usermgmt', 'customer']);
        },
        error: () => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Error in assigning/updating resources" });
        }
      })
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: `Select ${PROJECT_CONSTANTS.APPLICATION_NAME} before adding other resources.` })
    }
  }

  async handleViewOrEditCustomerOnRefresh(customerId: any) {
    if (this.currentTab == 'resources') {
      //* Get all assigned resources for all assigned apps
      //* for a customer Api Call
      await this.fetchAllAssignedResourcesUnderAssignedAppsForCustomer(customerId);
      this.fetchAllActiveApplications(customerId);
    } else if (this.currentTab != 'resources') {
      const options = {
        "uriParams": {
          customerId
        }
      };
      //* Get customer info by customer id api call
      this.loading = true;
      let customerInfo = await this.dataSrv.getCustomerInfoByCustomerId(options);
      this.loading = false;

      //* API call to fetch customer type dropdown values
      await this.fetchCustomerAttributes(customerInfo);
      //* Get customer admin info by customer id api call
      this.loading = true;
      this.customerAdminInfo = await this.dataSrv.getCustomerAdminInfoByCustomerId(options);
      this.loading = false;

      let { response: customerAdminResponse } = this.customerAdminInfo;

      if (this.utilSrv.isObjectNotNullAndEmpty(customerInfo)
        && this.utilSrv.isObjectNotNullAndEmpty(this.customerAdminInfo)) {
        let { response } = customerInfo;

        response['customerAdminEmail'] = customerAdminResponse?.length > 0
          ? customerAdminResponse?.[0]?.email_id
          : null;

        this.showCustomerAdmin = !!isNullOrUndefined(response['customerAdminEmail']);

        this.setCustomerDetails(response);
      }
    }
  }

  validateEmail(event: any) {
    let inputStr = event.target.value;
    this.isEmailValid = this.utilSrv.isEmailValid(this.emailPattern, inputStr);
  }

  setInitialCustomerInfo() {
    let { info, operation } = this.appState.getCustomerData();
    this.operation = operation;
    this.isApplicationTableDataLoaded = this.operation === 'new';

    if (!isNullOrUndefined(info)) {
      let { customerAdminEmail } = info;
      this.customerAdminEmail = customerAdminEmail;
      this.showCustomerAdmin = !(!isNullOrUndefined(customerAdminEmail) || operation === 'new');
    }

    if (operation === 'edit' || operation === 'view') {
      this.appState.setCurrentCustomerId(info.customerId);
      if (this.currentTab == 'info') {
        this.setCustomerDetails(info);
      }
      this.customerId = info.customerId;

      if (operation === 'view') {
        this.isEdit = false;
      }

      if ((this.isEdit || operation === 'view') && this.isCustomerDropdownRequired && this.currentTab != 'resources') {
        this.fetchCustomerAttributes();
      }

      if (this.customerDetails?.address && this.customerDetails?.billingAddress && this.customerDetails?.address != '' && this.customerDetails.address === this.customerDetails.billingAddress) {
        this.billingAddressToggleFlag = true;
      }
    }
  }

  setCustomerDetails(postData: any) {
    this.customerDetails = {
      customerName: postData['customerName'] ? postData['customerName'] : null,
      email: postData['email'] ? postData['email'] : null,
      address: postData['address'] ? postData['address'] : null,
      billingAddress: postData['billingAddress'] ? postData['billingAddress'] : null,
      primary_contact: postData?.['primaryContact'] ?? null,
      secondary_contact: null,
      customerAdminEmail: !isNullOrUndefined(this.customerAdminEmail)
        ? this.customerAdminEmail : postData['customerAdminEmail'],
      customerConfig: postData['customerConfig'],
      domain: postData['domain'],
    }
    if (this.customerDetails?.address && this.customerDetails?.billingAddress && this.customerDetails?.address != '' && this.customerDetails.address === this.customerDetails.billingAddress) {
      this.billingAddressToggleFlag = true;
    }
    if (!isNullOrUndefined(this.customerDetails['customerAdminEmail'])) {
      this.customerAdminEmail = this.customerDetails['customerAdminEmail'];
    }
    this.formDataCopy = {
      name: this.customerDetails['customerName'],
      email: this.customerDetails['email'],
      primary_contact: this.customerDetails['primaryMobileNo'],
      secondary_contact: this.customerDetails['secondaryMobileNo'],
      com_address: this.customerDetails['address'],
      billing_address: this.customerDetails['billingAddress'],
      customerConfig: this.customerDetails['customerConfig'],
      domain: this.customerDetails['domain'],
    }
    // if(this.customerDetails['customerConfig']) {
    //   this.getDataUrl(this.customerDetails['customerConfig'].dropDownConfig[0].values[0]).then((logo)=>{
    //     this.currentCustomerLogo = logo;
    //     this.formDataCopy['customerConfig'] = logo;
    //   })
    // }

    this.customerDetailsForm.patchValue({
      customerName: postData.customerName,
      email: postData.email,
      address: postData?.address ? postData.address : '',
      billingAddress: postData?.billingAddress ? postData.billingAddress : '',
      // logo: this.getDataUrl(postData.customerConfig.dropDownConfig.values[0]),
      domain: postData?.domain ? postData.domain : null,
    });
    try {
      let phoneNumberData = JSON.parse(this.customerDetails['primary_contact']);
      this.selectedCountry = phoneNumberData?.['country'];
      this.customPhoneForm.patchValue({
        country: phoneNumberData?.['country'],
        phoneNumber: phoneNumberData?.['phoneNumber']
      })
    } catch (e) {

    }
  }

  /**
   * 1. If checkbox is clicked then copy comm_addr to billing addr
   * 2. If checkbox is unselected then the fields are independent
   * 3. If checkbox is selected and billing_addr is modified then update comm_addr
   */

  billingAddressToggle() {
    if (this.billingAddressToggleFlag) {
      this.onCommAddressChanged();
      this.onBillingAddressChanged();
    } else {
      this.customerDetailsForm.get('billingAddress')?.setValue('')
    }
  }

  onCommAddressChanged(event: any = null) {
    if (this.billingAddressToggleFlag) {
      this.customerDetailsForm.get('billingAddress')?.setValue(this.customerDetailsForm.get('address')?.value);
    }
  }

  onBillingAddressChanged(event: any = null) {
    if (this.billingAddressToggleFlag) {
      this.customerDetailsForm.get('address')?.setValue(this.customerDetailsForm.get('billingAddress')?.value);
    }
  }

  onEditClick() {
    this.isEdit = true;
  }

  navigateToCustomerList() {
    this.router.navigate(['usermgmt', 'customer']);
  }

  navigateToEditView() {

    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;

    if (!isNullOrUndefined(this.customerId)) {
      this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
        queryParams: {
          operation: CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER,
          customerId: this.customerId
        }
      });
    }
  }


  onFormSubmit(nextstep: any) {
    let data = this.customerDetailsForm.value;
    if (this.customerId) {
      this.updateCustomer(data, nextstep);
    } else {
      this.addCustomer(data, nextstep);
    }
  }

  addCustomer(data: any, nextstep: any) {
    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;
    let postData = {
      meta: {
        customerName: data.customerName,
        purchasedPlan: null,
        email: data.email,
        primaryContact: this.customPhoneForm?.value ? JSON.stringify(this.customPhoneForm?.value) : null,
        secondaryContact: null,
        address: data.address,
        billingAddress: data.billingAddress,
        domain: data.domain,
        customerConfig: {
          dropDownConfig: this.areCustomerAttributesFilled ? this.customerAttributes : null
        }
      }
    };

    const formData = new FormData();
    formData.append("fileName", this.imageFile?.name);
    formData.append("uploadData", this.imageFile);
    formData.append("addCustomer", JSON.stringify(postData));
    this.loading = true;
    this.httpSrv.makePostApiCall('ADD_CUSTOMER', formData, this.envService.baseUrl).subscribe({
      next: (response: any) => {
        if (response.result) {
          this.isEdit = true;
          this.operation = CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER;
          this.customerId = response.response;
          this.showCustomerAdmin = !isNullOrUndefined(this.customerId);
          this.isResourceClickable = false;
          if (!isNullOrUndefined(this.customerId)) {
            this.router.navigate([], {
              queryParams: {
                config: 'admin',
                customerId: this.customerId,
                operation: CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER
              },
              queryParamsHandling: 'merge'
            });
            nextstep.emit();
            this.operation = 'edit';
            this.isEdit = this.operation === CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER;
            this.areCustomerAttributesFilled = !!this.isEdit;
            this.isApplicationTableDataLoaded = this.operation === CUSTOMER_MODULE_OPERATIONS.ADD_CUSTOMER;
            this.appState.setCurrentCustomerId(this.customerId);
          }
          this.appState.setCurrentCustomerId(this.customerId);
        }
      },
      complete: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Organization added successfully' })
        if (this.isCustomerDropdownRequired) {
          this.setCutomerTypeToCustomer();
        }
        this.handleViewOrEditCustomerOnRefresh(this.customerId);
        this.loading = false;
      },
      error: (err: any) => {
        let { error } = err;

        if (this.utilSrv.isObjectNotNullAndEmpty(error)) {
          let { message } = error;
          this.loading = false;

          if (!isNullOrUndefined(message)) {
            if (message.includes('customers_email_key')) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message })
            } else if (message.includes('customers_primary_contact_key')) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: "Primary mobile mumber already exists" })
            } else if (message.includes('customers_customer_name_key')) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: "Organization already exists" })
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message })
            }
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
          }
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
        }
      }
    });
  }

  disableScopeWhenNoRoleIsAssigned() {
    const elements = document.getElementsByClassName('p-stepper-action');
    if (!this.isResourceClickable) {
      elements[2]?.classList.add('p-disabled');
    } else {
      elements[2]?.classList.remove('p-disabled');
    }
  }

  setCutomerTypeToCustomer() {
    const promise = new Promise((resolve, reject) => {
      const postData = {
        cust_uuid: this.customerId,
        cust_type_uuid: this.selectedTypeValues['cust_type_uuid'],
        set_default_hierarchy: true
      }
      this.httpSrv.makePostApiCall('ADD_CUSTOMER_TYPE', postData, this.envService.applicationBaseUrl).subscribe({
        next: (res: any) => {
          resolve(true);
        },
        error: () => {
          resolve(false);
        }
      })
    })
    return promise;
  }

  check() {
  }

  getdata(data: any) {
    for (let key in this.applicationSelectedStatus) {
      const shouldAdd = this.applicationSelectedStatus[key];
      this.applicationsList.forEach((application) => {
        if (application['applicationName'] === key) {
          if (shouldAdd && !application['status']) {
            this.applicationIdsToAdd.push(application['applicationId']);
          } else if (!shouldAdd && application['status']) {
            this.applicationIdsToDelete.push(application['applicationId']);
          }
        }
      });
    }

    this.subscribeResourcesData()
    this.payloaddata['applicationIdsToAdd'] = this.applicationIdsToAdd;
    this.payloaddata['applicationIdsToDelete'] = this.applicationIdsToDelete;
    this.payloaddata['customerId'] = data['customerId'];
    this.payloaddata['resourceActionIdsToAdd'] = this.resourcesIdsList?.['resourceActionIdsToAdd']
    this.payloaddata['resourceActionIdsToDelete'] = this.resourcesIdsList?.['resourceActionIdsToDelete']
  }


  subscribeResourcesData() {
    const resourcesIDsSubscription = this.custService?.resourcesIDsIndex$.subscribe(
      (data: any) => {
        this.resourcesIdsList = data
      }
    );
    this.subscriptions.push(resourcesIDsSubscription);
  }

  updateCustomer(data: any, nextstep: any) {
    let postData = {
      meta: {
        customerName: data.customerName,
        purchasedPlan: null,
        email: data.email,
        primaryContact: this.customPhoneForm?.value ? JSON.stringify(this.customPhoneForm?.value) : null,
        secondaryContact: null,
        address: data.address,
        billingAddress: data.billingAddress,
        domain: data.domain,
        customerId: this.customerId,
        customerConfig: { dropDownConfig: [{ label: "logo", values: [this.formDataCopy.customerConfig] }] }
      }
    };

    let options = {
      uriParams: {
        "id": this.customerId
      }
    }

    let isFormValuesModified = this.dataSrv.areEditCustomerFormValuesModified(this.formDataCopy, data);

    if (isFormValuesModified) {
      const formData = new FormData();
      formData.append("addCustomer", JSON.stringify(postData));
      formData.append("fileName", this.imageFile?.name ?? "null");
      formData.append("uploadData", this.imageFile ?? "null");
      formData.append("isFileUpdated", this.imageFile ? JSON.stringify(true) : JSON.stringify(false));
      this.loading = true;
      this.httpSrv.makePostApiCall('UPDATE_CUSTOMER', formData, this.envService.baseUrl, options).subscribe({
        next: (response: any) => {
          if (response.result) {
            this.isEdit = false;

            let customerData = this.appState.getCustomerData();
            if (this.utilSrv.isObjectNotNullAndEmpty(customerData)) {
              customerData['operation'] = USER_MGMT_CNST.CUSTOMER_MODULE_OPERATIONS.VIEW_CUSTOMER
              this.appState.setCustomerData(customerData);
            }

            this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
              queryParams: {
                config: 'admin'
              },
              queryParamsHandling: 'merge'
            })
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Organization updated successfully' })
          }
        },
        complete: () => {
          this.handleViewOrEditCustomerOnRefresh(this.customerId);
          this.loading = false;
        },
        error: (err: any) => {
          const errorMessage = err?.error?.message
          this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage || "Failed to update the organization" });
          this.loading = false;
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "No field is edited for updating" })
    }
  }

  async fetchAllAssignedResourcesUnderAssignedAppsForCustomer(customerId: any = null) {
    // Api Parameters
    const options = {
      uriParams: {
        customerId: !isNullOrUndefined(customerId) ? customerId : this.appState.getCurrentCustomerId()
      }
    }
    this.loading = true;
    this.appsListWithResources = await this.dataSrv.fetchAllResourcesForAllAssignedAppsByCustomerId(options);
    if (!this.appsListWithResources) {
      this.loading = false;
    }
    let applicationsListResponse = this.appsListWithResources;

    this.isApplicationTableDataLoaded = true;

    let { response } = applicationsListResponse;

    if (!isNullOrUndefined(response)) {
      this.applicationsResourcesInfo = response;

      let applicationKeys = Object.keys(this.applicationsResourcesInfo);
      this.isApplicationsAssigned = applicationKeys.length > 0;

      if (this.isApplicationsAssigned) {
        //* Check if at least one application has any resources assigned
        //* If so, set hasAssignedResources to true and break the loop
        for (const applicationName of applicationKeys) {
          const hasResources = this.applicationsResourcesInfo[applicationName];
          const resourceKeys = Object.keys(hasResources);
          if (!isNullOrUndefined(hasResources) && resourceKeys.length > 0) {
            this.hasAssignedResources = true;
            break;
          }
        }
      }
    }
  }

  getLoadingflag(event: boolean) {
    this.applicationListLoading = event
  }
  async fetchCustomerAttributes(customerInfo: any = null) {

    let customerId = !isNullOrUndefined(this.customerId)
      ? this.customerId
      : this.appState.getCurrentCustomerId();

    let options = {
      uriParams: {
        customerId
      }
    }

    if (!isNullOrUndefined(customerId)) {
      let customerAttributes: any;
      if (!customerInfo) {
        this.loading = true;
        customerAttributes = await this.dataSrv.getCustomerInfoByCustomerId(options);
        this.loading = false;
      } else {
        customerAttributes = customerInfo;
      }

      if (this.utilSrv.isObjectNotNullAndEmpty(customerAttributes)) {
        let { response } = customerAttributes;
        if (this.utilSrv.isObjectNotNullAndEmpty(response)) {
          this.updateCustomerAttributes(response);
          this.areCustomerAttributesFilled = Object.values(this.selectedTypeValues).some(value => value !== '');
        }
      }
    }
  }

  updateCustomerAttributes(response: any) {
    let { customerConfig } = response;
    if (!isNullOrUndefined(customerConfig)) {
      let { dropDownConfig } = customerConfig;

      if (!isNullOrUndefined(dropDownConfig)) {
        dropDownConfig.forEach((config: any) => {
          let { label, values } = config;
          this.selectedTypeValues[label] = values[0];
        })
      }
    } else {
      const customerTypeId = this.customerAttributes ? this.customerAttributes?.[0]?.['values']?.[0] : null;
      const customerType = customerTypeId ? this.customerDropDownValues[0].values.find((type: any) => type['cust_type_uuid'] == customerTypeId) : '';
      this.selectedTypeValues['cust_type_uuid'] = customerType ? customerType['cust_type_name'] : null;
    }
  }

  onTypeChanged() {
    this.customerAttributes = this.dataSrv
      .buildCustomerAttributeValues(this.selectedTypeValues);

    this.areCustomerAttributesFilled = this.isCustomerAttributeValid();
  }


  isCustomerAttributeValid(): boolean {
    if (!this.isCustomerDropdownRequired) return this.areCustomerAttributesFilled;

    this.areCustomerAttributesFilled = this.customerAttributes.length > 0 &&
      this.dataSrv.checkIfAllAttributesAreFilled(this.customerAttributes);

    return this.areCustomerAttributesFilled;
  }

  fetchAllActiveApplications(customerId: any = null) {
   this.applicationListLoading = true
    let options = {
      'uriParams': {
        customerId: customerId || this.customerId
      }
    }

    if (!isNullOrUndefined(this.customerId)) {
      this.httpSrv.makeGetApiCall('GET_ALL_ACTIVE_APPLICATIONS', this.envService.baseUrl, options).subscribe({
        next: (applicationList: any) => {
          let { response } = applicationList;

          if (response && response.length > 0) {
            this.applicationsList = response;
          }
          if (this.applicationsList.length > 0) {
            this.applicationNames = this.applicationsList.map((item: any) => item.applicationName);
            this.applicationIds = this.applicationsList.map((item: any) => item.applicationId);
            this.initializeApplicationMaps();
          }
        },
        complete: () => { },
        error: (err: any) => {
          console.log("Error in fetching applications list ", err);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch application list" })
        }
      });
    }
  }

  // * Set all application selected status to false initially
  // * Build a map of application names to application ids
  initializeApplicationMaps() {

    this.applicationNames.forEach((name: string, index: number) => {

      let applicationObj = this.applicationsList.filter((item: any) => item.applicationName === name)[0];

      if (!isNullOrUndefined(applicationObj)) {

        let { isApplicationAssigned, resourceActionIds } = applicationObj;

        this.applicationSelectedStatus[name] = isApplicationAssigned;

        this.applicationNameIdMap[name] = this.applicationNameIdMap[name]
          ? this.applicationNameIdMap[name]
          : this.applicationIds[index];

        this.applicationNameResourceActionIdMap[name] = this.applicationNameResourceActionIdMap[name]
          ? this.applicationNameResourceActionIdMap[name]
          : resourceActionIds;
      }
    })

    this.applicationSelectedStatusCopy = { ...this.applicationSelectedStatus };
  }

  toggleApplicationSelectedStatus(applicationName: string, id: any) {
    this.applicationSelectedStatus[applicationName] = !this.applicationSelectedStatus[applicationName];
    if (!this.applicationSelectedStatus[applicationName]) {
      this.unchekedList.push(applicationName)
      const index = this.chekedList.indexOf(id);
      if (index !== -1) {
        this.chekedList.splice(index, 1);
      }
    }
    else {
      this.chekedList.push(id)
      for (let key in this.unchekedList) {
        if (this.unchekedList[key] == applicationName) {
          this.unchekedList[key] = null
          delete this.unchekedList[key]
        }
      }
    }
    this.isButtonEnabled = this.enableOrDisableButton();
  }

  enableOrDisableButton(): boolean {

    for (let applicationName in this.applicationSelectedStatusCopy) {

      let existingStatus = this.applicationSelectedStatusCopy[applicationName];
      let currentStatus = this.applicationSelectedStatus[applicationName];

      if ((existingStatus === true && currentStatus === false) ||
        (existingStatus === false && currentStatus === true)) {
        return true;
      }
    }

    return false;
  }

  assignOrUpdateApplications() {


    let postData: {
      "customerId": any,
      "assignedApplications": any[],
      "deletedApplications": any[],
      "resourceActionIds": any[]
    } = {
      "customerId": null,
      "assignedApplications": [],
      "deletedApplications": [],
      "resourceActionIds": []
    }

    //* If assign applications was clicked to open the modal
    const hasApplications = Object.keys(this.applicationsResourcesInfo).length > 0;
    const processApplications = (applicationStatusMap: any, existingMap?: any) => {
      for (let applicationName in applicationStatusMap) {
        const currentStatus = this.applicationSelectedStatus[applicationName];
        const applicationId = this.applicationNameIdMap[applicationName];

        if (hasApplications && currentStatus) {
          postData.assignedApplications.push(applicationId);
        } else if (!hasApplications && existingMap) {
          const existingStatus = existingMap[applicationName];

          if (existingStatus && !currentStatus) {
            postData.deletedApplications.push(applicationId);
            postData.resourceActionIds.push(...this.applicationNameResourceActionIdMap[applicationName]);
          } else if (!existingStatus && currentStatus) {
            postData.assignedApplications.push(applicationId);
          }
        }
      }
    };

    if (hasApplications) {
      processApplications(this.applicationSelectedStatus);
    } else {
      processApplications(this.applicationSelectedStatus, this.applicationSelectedStatusCopy);
    }

    if (!isNullOrUndefined(this.customerId)) {
      postData.customerId = this.customerId;
    }
    this.updateCustomerApplications(postData);
  }

  updateCustomerApplications(postData: any) {
    this.httpSrv.makePostApiCall('ASSIGN_UPDATE_CUSTOMER_APPLICATIONS', postData, this.envService.baseUrl).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Applications assigned/updated successfully' })
      },
      complete: () => { },
      error: (err: any) => {
        console.log("Error in assigning/updating applications ", err);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to assign/update application" })
      }
    });
  }

  navigateToEdit() {
    this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
      queryParams: {
        operation: 'edit'
      },
      queryParamsHandling: 'merge'
    })
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true; // Add a drag-over state
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false; // Remove the drag-over state
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false; // Remove the drag-over state

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const fileInput = this.fileInput.nativeElement;
      fileInput.files = event.dataTransfer.files;

      // Trigger the change event programmatically
      const changeEvent = new Event('change', { bubbles: true });
      fileInput.dispatchEvent(changeEvent);
      event.dataTransfer.clearData();
    }
  }

  onFileChange(event: any) {
    let fileInput = event?.target?.files;

    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (fileInput?.[0] && fileInput?.[0]?.size > maxSize) {
      this.messageService.add({severity:'error', summary:'Error', detail:'File size exceeds 5MB. Please select a smaller file.'});
      this.fileInput.nativeElement.value = '';
      return;
    }
    if (!fileInput?.[0]?.type.startsWith('image')) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Type is not supported' });
      this.fileInput.nativeElement.value = '';
      return;
    }

    if (fileInput?.[0].type.includes('svg')) {
      this.handleSvgFile(fileInput?.[0], event);
    } else {
      this.fileEvent = event;
      if (this.previousSelectedFile) {
        fileInput = this.createFileList(this.previousSelectedFile);
      } else {
        this.isImageInvalid = false
      }
      this.uploadImage(fileInput[0]);
    }
  }

  async handleSvgFile(file: File, event: Event) {
    try {
      const png = await this.utilSrv.convertSvgFileToPng(file);
      this.utilSrv.replaceFileInputWithNewFile(png);
      this.isImageInvalid = false;
      this.uploadImage(file);  // Use original or PNG based on requirement
      this.fileEvent = event;
    } catch (error) {
      console.error(error);
    }
  }

  createFileList(file: File): FileList {
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    return dataTransfer.files;
  }

  uploadImage(file: any) {
    if (!file) {
      this.isImageInvalid = this.operation !== 'new';
      return;
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.onload = () => {
        this.currentCustomerLogo = reader.result;
        this.previousSelectedFile = file;
        this.customerDetails.logo = file;
        this.isImageInvalid = false; // Mark image as valid
        this.imageFile = file;
        this.openCropPopUp = true;
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  removeUploadedFile() {
    this.currentCustomerLogo = '';
    this.isFileBrowserOpened = true;
  }

  checkLength(event: any) {
    let value = event.target.value;

    if (value.length > 0) {
      this.isPrimaryMobileNoValid = !this.customPhoneForm.invalid;
    } else {
      this.isPrimaryMobileNoValid = true;
    }
  }

  optionalValidator(requiredValidator: ValidatorFn): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value && control.value.trim() !== '') {
        return requiredValidator(control);
      }
      return null;
    };
  }

  get f() {
    return this.customerDetailsForm.controls;
  }

  ngOnDestroy(): void {
    this.custService.setResourcesIDs({
      'resourceActionIdsToAdd': [],
      'resourceActionIdsToDelete': []
    })
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  handleCropPopUp(event: any) {
    if (event !== null) {
      if (event) {
        this.imageFile = new File([event], this.utilSrv.generateRandomFileName(this.fileEvent.target.files?.[0]?.name || 'file.jpg'), { type: this.fileEvent.target.files?.[0]?.type || 'jpg' })
        this.utilSrv.blobToBase64(event).then((base64String: any) => {
          this.currentCustomerLogo = base64String;
        });
      }
    } else {
      this.imageFile = null;
      this.currentCustomerLogo = null;
    }
    this.openCropPopUp = false;
  }

  onFileFocus() {
    this.isFileBrowserOpened = true;
  }

  // async getDataUrl(imageUrl: string) {
  //   if(imageUrl) {
  //     return await this.utilSrv.getDataUrl(imageUrl, 'image/jpeg');
  //   }
  //   return '';
  // }
}